import { Injectable } from '@angular/core'
import { BrowserInformation } from 'src/app/domain/models/application/browser-information.model'

@Injectable({
  providedIn: 'root'
})
export class BrowserService {

  public getBrowserInformation(): BrowserInformation {
    return {
      isMobile: this.checkPlatformMobile(),
      browser: this.checkNavigator(),
      userAgent: navigator.userAgent
    } as BrowserInformation
  }

  public reloadPage(): void {
    window.location.reload()
  }

  private checkPlatformMobile(): boolean {
    let match = window.matchMedia

    if (match) return match('(pointer:coarse)').matches
    
    return false
  }

  private checkNavigator(): string {
  let navigatorBrowser: string = ''
  
  const navigatorUserAgent: string = navigator.userAgent

    if (navigatorUserAgent.indexOf('Chrome') > -1) navigatorBrowser = 'Google Chrome'
    else if (navigatorUserAgent.indexOf('Safari') > -1) navigatorBrowser = 'Apple Safari'
    else if (navigatorUserAgent.indexOf('Opera') > -1) navigatorBrowser = 'Opera'
    else if (navigatorUserAgent.indexOf('Firefox') > -1) navigatorBrowser = 'Mozilla Firefox'
    else if (navigatorUserAgent.indexOf('MSIE') > -1) navigatorBrowser = 'Microsoft Internet Explorer'

    return navigatorBrowser
  }
}
